import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

/** Blocks authenticated users from accessing login/register pages — redirects to dashboard. */
export const guestGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    // During SSR, allow rendering
    if (isPlatformServer(platformId) && !authService.isInitialized()) {
        return true;
    }

    // Already authenticated → redirect to dashboard
    if (authService.isAuthenticated()) {
        return router.createUrlTree(['/dashboard']);
    }

    // Session check done, not authenticated → allow access to login/register
    if (authService.isInitialized()) {
        return true;
    }

    // First load: check session, then decide
    return authService.checkSession().pipe(
        map(() => authService.isAuthenticated() ? router.createUrlTree(['/dashboard']) : true)
    );
};
